import React from 'react';

export default () => {
  return (
    <footer class="footer">
      <div class="footer-content">
        <p class="m-b-0">Copyright © {new Date().getFullYear()} HungHau Holdings. All rights reserved.</p>
        <span>
          <a href="" class="text-gray m-r-15">Term &amp; Conditions</a>
          <a href="" class="text-gray">Privacy &amp; Policy</a>
        </span>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js